"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteSdkClientRequestParams = void 0;
var AuthSuiteSdkClientRequestParams;
(function (AuthSuiteSdkClientRequestParams) {
    AuthSuiteSdkClientRequestParams["CallbackUrl"] = "callbackUrl";
    AuthSuiteSdkClientRequestParams["AuthorizationCode"] = "authorizationCode";
    AuthSuiteSdkClientRequestParams["ApplicationAccessToken"] = "applicationAccessToken";
    AuthSuiteSdkClientRequestParams["Email"] = "email";
    AuthSuiteSdkClientRequestParams["FilterType"] = "filterType";
    AuthSuiteSdkClientRequestParams["LogoSchema"] = "logoSchema";
    AuthSuiteSdkClientRequestParams["Purchases"] = "purchases";
    AuthSuiteSdkClientRequestParams["PurchaseToken"] = "purchaseToken";
    AuthSuiteSdkClientRequestParams["ResourceId"] = "resourceId";
    AuthSuiteSdkClientRequestParams["ResetToken"] = "resetToken";
    AuthSuiteSdkClientRequestParams["NewPassword"] = "newPassword";
    AuthSuiteSdkClientRequestParams["Password"] = "password";
    AuthSuiteSdkClientRequestParams["Profile"] = "profile";
    AuthSuiteSdkClientRequestParams["ResourceGroup"] = "resourceGroup";
    AuthSuiteSdkClientRequestParams["ActivationCode"] = "activationCode";
    AuthSuiteSdkClientRequestParams["BrandKidsFilterOn"] = "brandKidsFilterOn";
})(AuthSuiteSdkClientRequestParams = exports.AuthSuiteSdkClientRequestParams || (exports.AuthSuiteSdkClientRequestParams = {}));
